import React, { InputHTMLAttributes, ReactNode } from "react"
import cn from "classnames"
import Icon from "../general/Icon"
import { t } from "../../i18n"

interface SwitchProps {
  className?: string;
  children?: ReactNode;
  i18nKey?: string;
  input: InputHTMLAttributes<HTMLInputElement>;
}

const Switch: React.FC<SwitchProps> = (props: SwitchProps) => {
  const { children, i18nKey, input } = props
  const className = cn( "Switch", props.className, {
    "Switch--disabled": input.disabled,
    "Switch--checked": input.checked,
  })

  return (
    <label className={className}>
      <input {...input} className="Switch-input" type="checkbox"/>
      <span className="Switch-switch">
        <span className="Switch-circle">
          <Icon symbolId={input.checked ? "check" : "close"}/>
        </span>
      </span>
      <span className="Switch-label">{children || t(i18nKey)}</span>
    </label>
  )
}

export default Switch
